<template>
  <div>
    <!-- Version Release Modal -->
    <b-modal
      id="versionReleaseModal"
      :size="this.size"
      content-class="menu-bg-blue-transparent-modal vr-modal"
      body-class="p-0"
      title="Version Release Notes"
     
      scrollable
      @show="checkSize()"
    >
      <b-tabs content-class="mt-2" pills card justified>
        <b-tab
          title="Add Version"
          :active="activeTab == 'add'"
          @click="addNewVersion('lg')"
        >
          <b-card class="menu-bg-blue-transparent">
            <b-container>
              <b-row class="py-2">
                <b-col class="col-sm-12 px-5">
                  <div class="field px-5">
                    <label for="version">Version *</label>
                    <b-form-input
                      name="version"
                      autocomplete="off"
                      v-model="form.version"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row class="py-2">
                <b-col class="col-sm-12 px-5">
                  <div class="field px-5">
                    <label>Release Date *</label>
                    <b-form-input
                      class="form-control"
                      type="date"
                      placeholder="Release Date"
                      v-model="form.date"
                    ></b-form-input>
                  </div>
                </b-col>
              </b-row>
            </b-container>
            <b-container v-if="submitErrors.length">
              <b-col class="text-center">
                <span>
                  <b>Please correct the following error(s):</b>
                  <b-list-group>
                    <div
                      class="alert alert-danger"
                      v-for="error in submitErrors"
                      :key="error"
                    >
                      <b-list-group-item>{{ error }}</b-list-group-item>
                    </div>
                  </b-list-group>
                </span>
              </b-col>
            </b-container>
            <b-row class="p-3">
              <b-col class="text-center">
                <b-button
                  variant="primary"
                  class="btn-md m-2"
                  type="submit"
                  @click="checkVersion()"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab
          title="New Release Notes"
          :active="activeTab == 'new'"
          @click="addNewNote('lg')"
        >
          <b-card class="menu-bg-blue-transparent">
            <b-container>
              <b-row class="py-2">
                <b-col class="col-sm-12 px-5">
                  <div class="field px-5">
                    <label for="version">Version *</label>
                    <b-form-select
                      v-model="form.version_details"
                      @change="getReleaseDate($event)"
                    >
                      <option
                        v-for="(item, index) in this.versions"
                        :key="index"
                        :value="item"
                      >
                        {{ item.version }}
                      </option>
                    </b-form-select>
                  </div>
                </b-col>
              </b-row>
              <b-row class="py-2">
                <b-col class="col-sm-12 px-5">
                  <div class="field px-5">
                    <label>Release Date </label>
                    <b-form-input
                      class="form-control"
                      v-model="form.release_date"
                      placeholder="Release Date"
                      disabled
                    ></b-form-input>
                  </div>
                </b-col>
              </b-row>
              <b-row class="py-2">
                <b-col class="col-sm-12 px-5">
                  <div class="field px-5">
                    <label>Organization *</label>
                    <b-form-select v-model="form.org">
                      <option
                        v-for="(org, index) in this.organizations"
                        :key="index"
                        :value="org.id"
                      >
                        {{ org.company_name }}
                      </option>
                    </b-form-select>
                  </div>
                </b-col>
              </b-row>
              <b-row class="py-2">
                <b-col class="col-sm-12 px-5">
                  <div class="field px-5">
                    <label for="notes">Notes *</label>
                    <b-form-textarea
                      name="notes"
                      type="textarea"
                      autocomplete="off"
                      v-model="form.notes"
                    />
                  </div>
                </b-col>
              </b-row>
            </b-container>
            <b-container v-if="submitErrors.length">
              <b-col class="text-center">
                <span>
                  <b>Please correct the following error(s):</b>
                  <b-list-group>
                    <div
                      class="alert alert-danger"
                      v-for="error in submitErrors"
                      :key="error"
                    >
                      <b-list-group-item>{{ error }}</b-list-group-item>
                    </div>
                  </b-list-group>
                </span>
              </b-col>
            </b-container>
            <b-row class="p-3">
              <b-col class="text-center">
                <b-button
                  v-if="!this.updateEntryID"
                  variant="primary"
                  class="btn-md m-2"
                  type="submit"
                  @click="checkForm()"
                >
                  Submit
                </b-button>
                <b-button
                  v-if="this.updateEntryID"
                  variant="primary"
                  class="btn-md m-2"
                  type="submit"
                  @click="checkForm()"
                >
                  Update
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab
          title="Unreleased Notes"
          :active="activeTab == 'unreleased'"
          @click="getUnreleasedVersion('lg')" 
        >
          <b-row class="pb-3">
            <b-col class="text-center">
              <b-button
                variant="danger"
                class="btn-md"
                type="submit"
                @click="release()"
              >
                Release Notes
              </b-button>
            </b-col>
          </b-row>

          <vue-bootstrap4-table
            :columns="releaseColumns"
            :config="releaseconfig"
            :rows="releaseRows"
            :classes="classes"
          >
          </vue-bootstrap4-table>
        </b-tab>
        <b-tab
          title="Versions"
          :active="activeTab == 'version'"
          @click="showVersions('lg')"
        >
          <vue-bootstrap4-table
            :rows="versionDetailsRows"
            :columns="versionDetailsColumns"
            :config="config"
            :classes="classes"
          >
          </vue-bootstrap4-table>
        </b-tab>
        <b-tab
          title="Release Notes"
          :active="activeTab == 'history'"
          @click="getReleaseVersions('xl')" 
        >
          <vue-bootstrap4-table
            :rows="versionRows"
            :columns="versionColumns"
            :config="config"
            :classes="classes"
          >
            <template slot="update" slot-scope="props">
              <b-button variant="info" @click="updateEntry(props.row)">
                <fa :icon="['fas', 'pencil-alt']" size="lg" />
              </b-button>
            </template>
            <template slot="delete" slot-scope="props">
              <b-button variant="danger" @click="deleteEntry(props.row)">
                <fa :icon="['fas', 'minus']" size="lg" />
              </b-button>
            </template>
          </vue-bootstrap4-table>
        </b-tab>
        <b-tab
          title="Tutorials"
          :active="activeTab == 'tutorial'"
          @click="getTutorials()" 
        >
          <b-row class="pb-3">
            <b-col class="text-center">
              <b-button
                variant="danger"
                class="btn-md"
                type="submit"
                @click="releaseTutorials()"
              >
                Release Tutorials
              </b-button>
            </b-col>
          </b-row>
          <vue-bootstrap4-table
            :rows="tutorialRows"
            :columns="tutorialColumns"
            :config="config"
            :classes="classes"
            :actions="tutorialsActions"
            @add="initAddTutorial()"
          >
            <template slot="active" slot-scope="props">
              <b-button 
                :variant="!props.row.active ? 'primary' : 'danger'" 
                @click="changeTutorialVisibility(props.row)"
              >{{ !props.row.active ? 'PUBLISH' : 'UNPUBLISH' }}</b-button>
            </template>
            <template slot="update" slot-scope="props">
                <button class="btn" @click="initUpdateTutorial(props.row)" style="color: #063c6d;">
                    <fa :icon="['fas', 'pencil-alt']" size="lg" />
                </button>
            </template>
          </vue-bootstrap4-table>
        </b-tab>
      </b-tabs>
    </b-modal>
    <MMP_TutorialsModal :tutorial="selectedTutorial" @refresh="getTutorials"></MMP_TutorialsModal>
  </div>
</template>

<style>
.vr-modal .menu-bg-blue-transparent,
.vr-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.vr-modal table { color: #063c6d !important; text-shadow: none !important; }
.vr-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.vr-modal thead th a,
.vr-modal thead th svg { color: rgba(6, 60, 109, 0.5) !important; }
.vr-modal tbody tr { color: #063c6d !important; text-shadow: none !important; }
.vr-modal tbody tr:hover { background: rgba(6, 60, 109, 0.04) !important; }
.vr-modal tbody td {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.vr-modal .footer-pagination-row td,
.vr-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
}
.vr-modal .nav-pills .nav-link {
  color: rgba(6, 60, 109, 0.65);
  background: transparent;
  border: 1px solid rgba(6, 60, 109, 0.3);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  margin: 0 4px;
  transition: background 0.15s;
}
.vr-modal .nav-pills .nav-link.active {
  background: #063c6d !important;
  color: #fff !important;
  border-color: #063c6d !important;
}
.vr-modal label { color: rgba(6, 60, 109, 0.7); }
.vr-modal .form-control {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
}
.vr-modal .form-control::placeholder { color: rgba(6, 60, 109, 0.35); }
.vr-modal .form-control:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}
</style>

<script>
import 'vue-date-pick/dist/vueDatePick.css'
import DatePick from 'vue-date-pick'
import Multiselect from 'vue-multiselect'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import axios from 'axios'
import MMP_TutorialsModal from './MMP_TutorialsModal.vue'
export default {
  name: 'MMP_VersionRelease',
  components: {
    Multiselect,
    VueBootstrap4Table,
    DatePick,
    MMP_TutorialsModal
  },
  data() {
    return {
      form: {
        version: null,
        notes: null,
        date: null,
        org: null,
        org_name: null,
        version_details: null,
        release_date: null
      },
      versions: [],
      organizations: [],
      versionId: [],
      submitErrors: [],
      versionRows: [],
      versionColumns: [
        {
          label: 'Version',
          name: 'version',
          sort: true
        },
        {
          label: 'organization',
          name: 'organization_name',
          sort: true
        },
        {
          label: 'Release Date',
          name: 'release_date',
          sort: true
        },
        {
          label: 'Notes',
          name: 'notes',
          sort: false
        },
        {
          label: 'Released',
          name: 'released',
          sort: false
        },
        {
          label: 'Update',
          name: 'update',
          sort: false
        },
        {
          label: 'Delete',
          name: 'delete',
          sort: false
        }
      ],
      config: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        show_refresh_button: false,
        show_reset_button: false,
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        color: 'white'
      },
      releaseColumns: [
        {
          label: 'Version',
          name: 'version',
          sort: false
        },
        {
          label: 'organization',
          name: 'organization_name',
          sort: false
        },
        {
          label: 'Release Date',
          name: 'release_date',
          sort: false
        },
        {
          label: 'Notes',
          name: 'notes',
          sort: false
        }
      ],
      tutorialRows: [],
      tutorialColumns: [
        {
          label: 'ID',
          name: 'id',
          sort: false
        },
        {
          label: 'Name',
          name: 'name',
          sort: false
        },
        {
          label: 'Description',
          name: 'description',
          sort: false
        },
        {
          label: 'Update',
          name: 'update',
          sort: false
        },
        {
          label: 'Visibility',
          name: 'active',
          sort: false
        }
      ],
      tutorialsActions: [
        {
            btn_text: "Add New Tutorial",
            event_name: "add",
            class: "btn btn-primary",
        }
      ],
      releaseconfig: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          visibility: false
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        show_refresh_button: false,
        show_reset_button: false
      },
      size: '',
      releaseRows: [],
      updateEntryID: null,
      activeTab: null,
      versionDetailsRows: [],
      versionDetailsColumns: [
        {
          label: 'Version',
          name: 'version',
          sort: true
        },
        {
          label: 'Release Date',
          name: 'release_date',
          sort: true
        },
        {
          label: 'Created Date',
          name: 'created_date',
          sort: true
        }
      ],
      classes: {
        table: {
          'menu-bg-blue-transparent': true
        }
      },
      selectedTutorial: {}
    }
  },
  methods: {
    getCompanies() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/company/', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Companies API Call Error: ' + content.errors)
            } else {
              let arr = {
                company_name: 'All',
                created_at: null,
                description: 'All',
                id: 0,
                updated_at: null
              }
              content.push(arr)
              this.organizations = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getReleaseVersions() {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION + '/api/release_notes/getVersionReleases',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getVersionReleases API Call Error: ' + content.errors) // refactored to provide better error msg
            } else {
              this.activeTab = 'history'
              this.changeSize('xl')
              this.versionRows = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getVersions() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/release_notes/getVersions', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getVersions API Call Error: ' + content.errors) // refactored error message to be more specific
            } else {
              this.versions = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getAllVersions() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/release_notes/getAllVersions', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getAllVersions API Call Error: ' + content.errors) // refactored error message to be more specific
            } else {
              this.versionDetailsRows = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    checkForm() {
      this.submitErrors = []
      if (this.form.version_details == null) {
        this.submitErrors.push('Please select version.')
      }
      if (this.form.notes == null) {
        this.submitErrors.push('Please enter notes.')
      }
      if (this.form.org == null) {
        this.submitErrors.push('Please select organization.')
      }
      if (!this.submitErrors.length) {
        if (!this.updateEntryID) {
          this.submit()
        } else {
          this.update()
        }
      }
    },
    checkVersion() {
      this.submitErrors = []
      if (this.form.version == null) {
        this.submitErrors.push('Please enter version.')
      }
      if (this.form.date == null) {
        this.submitErrors.push('Please enter date.')
      }
      if (!this.submitErrors.length && sessionStorage.token) { // added sessionStorage.token check
        axios
          .get(process.env.API_LOCATION + '/api/release_notes/addVersion', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': sessionStorage.token
            },
            params: {
              version: this.form.version,
              date: this.form.date
            }
          })
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.$bvToast.toast('New version added.', {
                title: 'Status',
                toaster: 'b-toaster-top-center'
              })
              this.form.version = null
              this.form.date = null
            } else {
              console.log('addVersion API Call Error: ' + content.errors) // refactored to add console log for api call
            }
          })
          .catch(function (error) {
              console.log(error) // refactored to console log error message
          })
      }
    },
    feedbackHide() {
      this.submitErrors = []
    },
    clearForm() {
      this.form = {
        version: null,
        notes: null,
        date: null,
        org: null,
        org_name: null,
        version_details: null,
        release_date: null
      }
      this.submitErrors = []
    },
    submit() {
      if (sessionStorage.token) {
        let company_name = this.organizations.filter(
          e => e.id == this.form.org
        )[0].company_name
        axios
          .get(
            process.env.API_LOCATION + '/api/release_notes/addVersionRelease',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                version_id: this.form.version_details.version_id,
                notes: this.form.notes,
                org_id: this.form.org,
                org_name: company_name
              }
            }
          )
          .then(response => {
            const content = response.data
            this.activeTab = 'history'
            this.getReleaseVersions('xl')
            if (!content.errors) {
              this.$bvToast.toast('New version release notes added.', {
                title: 'Status',
                toaster: 'b-toaster-top-center'
              })
            } else {
              console.log('addVersionRelease API Call Error: ' + content.errors) // refactored to add console msg for errors
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
      this.clearForm()
    },
    checkSize() { // removed unused paramater from function declaration
      this.size = this.activeTab == 'history' ? 'xl' : 'lg'
      this.changeSize(this.size)
    },
    changeSize(value) {
      this.size = value
    },
    getUnreleasedVersion(size) { // removed unused parameter from function declaration
      this.activeTab = 'unreleased'
      this.changeSize(size)
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
              '/api/release_notes/getUnreleasedVersion',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getUnreleasedVersion API Call Error: ' + content.errors) // refactored to be more specific error msg
            } else {
              this.versionId = []
              this.releaseRows = content
              content.forEach(element => {
                this.versionId.push(element.id)
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    release() {
      // refactored to add check for sessionStorage.token
      if (sessionStorage.token) {
        if (this.versionId.length) { 
          axios
            .get(process.env.API_LOCATION + '/api/release_notes/release', {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                id: this.versionId.toString()
              }
            })
            .then(response => {
              this.releaseRows = []
              this.$bvToast.toast('Notes released.', {
                title: 'Status',
                toaster: 'b-toaster-top-center'
              })
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      } else {
        console.log('No User Token')
      }
      
    },
    updateEntry(row) {
      this.activeTab = 'new'
      this.changeSize('lg')
      this.editEntry(row.id)
    },
    editEntry(id) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/release_notes/getNotes', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: id
            }
          })
          .then(response => {
            const content = response.data[0]
            if (content.errors) {
              console.log('Update Entry API Call Error: ' + content.errors)
              // Else no errors and we can load returned entry into form
            } else {
              this.form = {
                version_details: this.versions.filter(
                  e => e.version_id == content.version_id
                )[0],
                org: content.organization_id,
                notes: content.notes,
                release_date: content.release_date
              }
              this.updateEntryID = content.id
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    deleteEntry(row) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/release_notes/deleteNotes', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: row.id
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Delete Entry API Call Error: ' + content.errors) // updated error message to actually say correct API call...
              // Else no errors and we can load returned entry into form
            } else {
              for (let i = this.versionRows.length - 1; i >= 0; i--) {
                if (this.versionRows[i].id == row.id) { // refactored from === to == - no need to be the same object
                  this.versionRows.splice(i, 1)
                }
              }
              this.$bvToast.toast(
                'Notes for version ' + row.version + ' deleted.',
                {
                  title: 'Status',
                  toaster: 'b-toaster-top-center'
                }
              )
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    update() {
      let company_name = this.organizations.filter(
        e => e.id == this.form.org
      )[0].company_name
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
              '/api/release_notes/updateVersionRelease',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                version_id: this.form.version_details.version_id,
                notes: this.form.notes,
                org_id: this.form.org,
                org_name: company_name,
                id: this.updateEntryID
              }
            }
          )
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.updateEntryID = null
              this.activeTab = 'history'
              this.getReleaseVersions('xl') // removed unnecessary arg
              this.$bvToast.toast('Version release notes updated.', {
                title: 'Status',
                toaster: 'b-toaster-top-center'
              })
            } else {
              console.log('updateVersionRelease API Call Error: ' + content.errors) // added this error console message
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
      this.clearForm()
      this.activeTab = 'history'
      this.changeSize('xl')
    },
    addNewNote(size) {
      this.activeTab = 'new'
      this.getCompanies()
      this.getVersions()
      this.changeSize(size)
      this.clearForm()
    },
    getReleaseDate(e) {
      this.form.release_date = this.versions.filter(
        i => i.version_id == e.version_id
      )[0].release_date
    },
    addNewVersion(size) {
      this.activeTab = 'add'
      this.changeSize(size)
      this.getVersions()
      this.submitErrors = []
    },
    showVersions(size) {
      this.activeTab = 'version'
      this.changeSize(size)
      this.getAllVersions()
    },
    getTutorials() {
      if (sessionStorage.token) {
        axios
        .get(process.env.API_LOCATION + '/api/tutorial/getAllTutorials', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getAllTutorials API Call Error: ' + content.errors)
            } else {
              this.activeTab = 'tutorial'
              this.changeSize('xl')
              this.tutorialRows = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    releaseTutorials() {
      console.log('implement this')
      if (sessionStorage.token) {
        axios.put(process.env.API_LOCATION + '/api/tutorial/publishAllTutorials',
          {
            headers: {
              'x-auth-token': sessionStorage.token
            },
          }
        ).then(response => {
          const content = response.data
          if (content.errors) {
            console.log(content.errors)
          } else {
            this.$bvToast.toast('Tutorials published successfully!', {
              title: 'Status',
              toaster: 'b-toaster-top-center',
              autoHideDelay: 5000,
              variant: 'success',
            })
            this.getTutorials()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        console.log('No User Token')
      }
    },
    changeTutorialVisibility(row) {
      if (sessionStorage.token) {
        let body = {
          id: row.id,
          value: !row.active
        }
        axios.put(process.env.API_LOCATION + '/api/tutorial/updateTutorialVisibility', body,
          {
            headers: {
              'x-auth-token': sessionStorage.token
            },
          }
        ).then(response => {
          const content = response.data
          if (content.errors) {
            console.log(content.errors)
          } else {
            this.$bvToast.toast('Tutorial updated successfully!', {
              title: 'Status',
              toaster: 'b-toaster-top-center',
              autoHideDelay: 5000,
              variant: 'success',
            })
            this.getTutorials()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        console.log('No User Token')
      }
    },
    initAddTutorial() {
      this.selectedTutorial = null;
      this.$bvModal.show('tutorialsModal')
    },
    initUpdateTutorial(row) {
      this.selectedTutorial = row;
      this.$bvModal.show('tutorialsModal')
    }
  },
  created() {
    this.getVersions()
  }
}
</script>
